import React from 'react';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import {
  ClaimAcknowledgementStatusDTO,
} from 'dtos';
import Tag from 'core/components/Tag';
import ClaimAcknowledgementPopover from 'pages/Dashboard/pages/Billing/Charges/ClaimAcknowledgementPopover';

export default function ClaimAcknowledgementStatus(props: ClaimAcknowledgementStatusDTO) {
  const {
    claimStatusCategoryCode,
    statusCode,
  } = props;
  return (
    <Tag
      className="font-semibold bg-gray-200 !text-gray-700 claim-acknowledgement-tag"
      tooltip={<ClaimAcknowledgementPopover {...props} />}
      tooltipProps={{ placement: 'right', isInteractive: true }}
    >
      <div className="flex items-center gap-1">
        <InfoIcon className="tag-icon !w-4 !h-4" />
        <span className="claim-acknowledgement-tag-info">
          {[
            claimStatusCategoryCode,
            statusCode,
          ].join(' / ')}
        </span>
      </div>
    </Tag>
  );
}
